/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 17:15:27
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-08-14 18:00:48
 * @FilePath: /dbrank_b/src/routes/visualChart/router.js
 * @Description: 路由组件和表头
 */
import P1 from "./P1";
import P2 from "./P2";
import P3 from "./P3";
import P4 from "./P4";
import P5 from "./P5";
import P6 from "./P6";
import P7 from "./P7";
import P8 from "./P8";
import P9 from "./P9";
import P10 from "./P10";
import P11 from "./P11";
import P12 from "./P12";
import P13 from "./P13";
import P14 from "./P14";
import P15 from "./P15";
import P16 from "./P16";
import P17 from "./P17";
import P18 from "./P18";
import P19 from "./P19";
import P20 from "./P20";
import P21 from "./P21";
import P22 from "./P22";
import P23 from "./P23";
import P24 from "./P24";
import P25 from "./P25";
import P26 from "./P26";
import P27 from "./P27";
import P28 from "./P28";
import P29 from "./P29";
import P30 from "./P30";
import P31 from "./P31";
import P32 from "./P32";
import P33 from "./P33";
import P34 from "./P34";
import P35 from "./P35";
import P36 from "./P36";
import P37 from "./P37";
import P38 from "./P38";
import P39 from "./P39";
import P40 from "./P40";
import P41 from "./P41";
import P42 from "./P42";
import P43 from "./P43";
import P44 from "./P44";
import P45 from "./P45";
// import P46 from "./P46";
// import P47 from "./P47";
// import P49 from "./P49";









export default [
  {
    path: 'p1',
    page: 'P1',
    title: '黄区自媒体月度变化趋势',
    component: P1,
  },
  {
    path: 'p2',
    page: 'P2',
    title: '红区自媒体月度变化趋势',
    component: P2,
  },
  {
    path: 'p3',
    page: 'P3',
    title: '参展商品牌头部内容引爆力前10名',
    component: P3,
  },
  {
    path: 'p4',
    page: 'P4',
    title: '安踏品牌历史累积数字品牌价值涨跌',
    component: P4,
  },
  {
    path: 'p5',
    page: 'P5',
    title: '单月对比数据概览',
    component: P5,
  },
  {
    path: 'p6',
    page: 'P6',
    title: '小罐茶现状认知-品牌方向',
    component: P6,
  },
  {
    path: 'p7',
    page: 'P7',
    title: '安踏VS竞品｜主要传播关键词对比',
    component: P7,
  },
  {
    path: 'p8',
    page: 'P8',
    title: '小罐茶VS竞品｜认知关键词对比',
    component: P8,
  },
  {
    path: 'p9',
    page: 'P9',
    title: '公众认知匹配度分析',
    component: P9,
  },
  {
    path: 'p10',
    page: 'P10',
    title: '安踏VS竞品 | 特定平台传播引爆力效果分析',
    component: P10,
  },
  {
    path: 'p11',
    page: 'P11',
    title: '媒介渠道分类对比-按媒体源',
    component: P11,
  },
  {
    path: 'p12',
    page: 'P12',
    title: '媒介渠道分类对比-按平台',
    component: P12,
  },
  {
    path: 'p13',
    page: 'P13',
    title: '安踏VS竞品 | 重点媒体传播效果-新华社系',
    component: P13,
  },
  {
    path: 'p14',
    page: 'P14',
    title: '安踏VS竞品 | 重点媒体传播效果-微博',
    component: P14,
  },
  {
    path: 'p15',
    page: 'P15',
    title: '安踏VS竞品 | KOL占比状况对比',
    component: P15,
  },
  {
    path: 'p16',
    page: 'P16',
    title: '安踏VS竞品 | 各圈层主要KOL合作对比',
    component: P16,
  },
  {
    path: 'p17',
    page: 'P17',
    title: '安踏VS竞品｜全网好感度整体分析',
    component: P17,
  },
  {
    path: 'p18',
    page: 'P18',
    title: '安踏｜各平台好感度分析',
    component: P18,
  },
  {
    path: 'p19',
    page: 'P19',
    title: '全年好感度变化',
    component: P19,
  },
  {
    path: 'p20',
    page: 'P20',
    title: '用户体验“3E”感知维度整体数据对比 | 品牌整体',
    component: P20,
  },
  {
    path: 'p21',
    page: 'P21',
    title: '负面话题点及正面修复程度分析',
    component: P21,
  },
  {
    path: 'p22',
    page: 'P22',
    title: '各平台五级情感倾向分析',
    component: P22,
  },
  {
    path: 'p23',
    page: 'P23',
    title: '海信VS竞品 | 官方自媒体贡献度对比分析',
    component: P23,
  },
  {
    path: 'p24',
    page: 'P24',
    title: '全年行业热点事件与传播趋势',
    component: P24,
  },
  {
    path: 'p25',
    page: 'P25',
    title: '品牌传播案例库周榜',
    component: P25,
  },
  {
    path: 'p26',
    page: 'P26',
    title: 'ESG传播影响力最高媒体源TOP10',
    component: P26,
  },
    {
    path: 'p27',
    page: 'P27',
    title: '汽车厂商用户心智榜TOP20',
    component: P27,
  },
  {
    path: 'p28',
    page: 'P28',
    title: '伊利单日数字品牌价值涨跌与影响因素',
    component: P28,
  },
  {
    path: 'p29',
    page: 'P29',
    title: '安踏VS竞品 | 全网好感度对比分析',
    component: P29,
  },
  {
    path: 'p30',
    page: 'P30',
    title: '传播可见度分析',
    component: P30,
  },
  {
    path: 'p31',
    page: 'P31',
    title: '热度 | 安踏VS竞品 传播可见度分析',
    component: P31,
  },
  {
    path: 'p32',
    page: 'P32',
    title: '卡萨帝 VS 竞品 | 传播可见度分析',
    component: P32,
  },
  {
    path: 'p33',
    page: 'P33',
    title: '安踏VS竞品 | 全媒介渠道整体传播效果对比-按媒体源',
    component: P33,
  },
  {
    path: 'p34',
    page: 'P34',
    title: '安踏VS竞品 | 全媒介渠道整体传播效果对比-按发布平台',
    component: P34,
  },
  {
    path: 'p35',
    page: 'P35',
    title: '伊利VS蒙牛 | 单日传播效果涨跌对比与关键动作',
    component: P35,
  },
  {
    path: 'p36',
    page: 'P36',
    title: '伊利VS蒙牛 | 202308-202407单日数字品牌价值涨跌对比',
    component: P36,
  },
  {
    path: 'p37',
    page: 'P37',
    title: '各话题方向对索尼数字品牌价值贡献度分析',
    component: P37,
  },
  {
    path: 'p38',
    page: 'P38',
    title: '索尼｜全网好感度分析',
    component: P38,
  },
  {
    path: 'p39',
    page: 'P39',
    title: '安踏 | 负面发酵率与负面认知分析',
    component: P39,
  },
  {
    path: 'p40',
    page: 'P40',
    title: '安踏儿童VS竞品|KOL整体参与度对比',
    component: P40,
  },
  {
    path: 'p41',
    page: 'P41',
    title: '周榜-封面',
    component: P41,
  },
  {
    path: 'p42',
    page: 'P42',
    title: '周榜-BKM案例整体表现',
    component: P42,
  },
  {
    path: 'p43',
    page: 'P43',
    title: '热梗封面',
    component: P43,
  },
  {
    path: 'p44',
    page: 'P44',
    title: '热梗内容',
    component: P44,
  },
  {
    path: 'p45',
    page: 'P45',
    title: 'highlight',
    component: P45,
  },
  // {
  //   path: 'p46',
  //   page: 'P46',
  //   title: '霸王茶姬VS喜茶 数字品牌资产历史累积走势对比',
  //   component: P46,
  // },
  //   {
  //   path: 'p47',
  //   page: 'P47',
  //   title: '本品VS竞品 | 传播引爆度对比分析',
  //   component: P47,
  // },
  // {
  //   path: 'p49',
  //   page: 'P49',
  //   title: '周榜模拟',
  //   component: P49,
  // }
]


// WEBPACK FOOTER //
// src/routes/visualChart/router.js